import React, {useEffect, useRef} from "react";

import {Box, Button, Typography} from "@mui/material";

import MaskSelectorToolStyles from "./MaskSelectorToolStyles";
import {useTranslation} from "react-i18next";

import { sendGAPageView } from "ui-common/GoogleAnalytics";

import automatic_scan from "./img/automatic_scan.svg";

import DataCollectionPopUp from "./DataCollectionPopUp";
import StepTitle from "./StepTitle";

import { scrollToTop } from "ui-common/components/common";

const SizingScanChoicePage = ( { chooseScan, chooseManual }) => {

    const { t } = useTranslation("pages.MaskSelectorTool.ChooseMaskSizingMethod");
    const { t: tPatientInfo } = useTranslation("pages.MaskSelectorTool.PatientInformation");

    // Localization strings
    const heading = t("myMeasurementsTitle");
    const subHeading = t("scanDescription2");
    const noCameraPath = t("noCameraPath");

    const scanPopupLink = t("scanPopupLink");

    const continueButton = tPatientInfo("continueButton")

    const {classes} = MaskSelectorToolStyles();

    const headingRef = useRef(null);

    useEffect(() => { 
        scrollToTop();

        if(headingRef.current) {
            headingRef.current.focus();
        }
    }, []);

    const openPopOver = (event) => {
        event.preventDefault();
        setOpen(true);

        sendGAPageView("MeasureMethodPopOver");
    };

    const [open, setOpen] = React.useState(false);
    const handleClose = () => { setOpen(false); };

    return (
        <>
            <Box className={classes.chooseTopTextBox}>
                <StepTitle title={heading} />
            </Box>

            <Box className={classes.centeredBox}>
                <img className={classes.auto_scan_resp_icon} src={automatic_scan} alt=""/>
            </Box>

            <Box className={classes.dne}>
                <Typography className={`${classes.subHeadingTyp} ${classes.noOutline}`} tabIndex="0" aria-label={subHeading}>{subHeading}</Typography>
            </Box>

            <Box mt="16px">
                <a href="#" className={classes.optionCardPopupLink} onClick={openPopOver}>{scanPopupLink}</a>
            </Box>


            <Box className={classes.choice_continue_box}>
                <Box>
                    <Button
                        disableRipple
                        onClick={chooseScan}
                        variant="contained"
                        color="secondary"
                        data-testid="scan-choice-continue-button"
                        className={classes.choice_continue_button}
                    >
                        <span>{continueButton}</span>
                    </Button>
                </Box>
                <Box className={classes.centeredBoxIfPhone}>
                    <a href="#" className={classes.optionCardPopupLink} onClick={chooseManual} data-testid="manual-measurements-link">{noCameraPath}</a>
                </Box>

            </Box>



            <DataCollectionPopUp open={open} onClose={handleClose} />



        </>
    )
}

export default SizingScanChoicePage;